/**
 * 用户反馈模块 - 中文翻译
 */
export const zh = {
  // 模块标题
  title: '用户反馈',
  subtitle: '提交反馈和建议',
  myFeedback: '我的反馈',
  feedbackManagement: '反馈管理',
  
  // Overview 页面
  overview: {
    quickActions: '快捷操作',
    submitFeedback: '提交反馈',
    submitFeedbackDesc: '报告问题或提出建议，帮助我们改进',
    myFeedbackDesc: '查看全部 {count} 条反馈记录',
    statsDesc: '查看反馈趋势和处理效率',
    recentFeedback: '最近反馈',
    viewAll: '查看全部',
    noFeedback: '暂无反馈',
    noFeedbackDesc: '您还没有提交过任何反馈',
    learnMore: '了解更多',
  },

  // 反馈类型
  typeBug: '问题反馈',
  typeFeature: '功能建议',
  typeImprovement: '改进建议',
  typeOther: '其他',

  // 反馈状态
  statusPending: '待处理',
  statusInProgress: '处理中',
  statusResolved: '已解决',
  statusClosed: '已关闭',

  // 优先级
  priorityLow: '低',
  priorityMedium: '中',
  priorityHigh: '高',
  priorityUrgent: '紧急',
  priorityUnset: '未设置',

  // 表单
  form: {
    title: '提交反馈',
    editTitle: '编辑反馈',
    type: '反馈类型',
    typePlaceholder: '请选择反馈类型',
    feedbackTitle: '标题',
    feedbackTitlePlaceholder: '请简要描述您的反馈',
    content: '详细描述',
    contentPlaceholder: '请详细描述您遇到的问题或建议...',
    attachments: '附件链接',
    attachmentsPlaceholder: 'https://example.com/screenshot.png',
    attachmentsHint: '最多 5 个图片链接',
    dragOrClick: '点击或拖拽上传',
    submit: '提交反馈',
    submitting: '提交中...',
    cancel: '取消',
    success: '反馈提交成功',
    successDesc: '感谢您的反馈，我们会尽快处理！',
  },

  // 列表
  list: {
    empty: '暂无反馈',
    emptyDesc: '您还没有提交过任何反馈',
    adminEmptyDesc: '当前没有用户反馈',
    searchPlaceholder: '搜索标题或内容...',
    allTypes: '全部类型',
    allStatus: '全部状态',
    allPriority: '全部优先级',
    allRegions: '全部区域',
    filter: '筛选',
    reset: '重置',
    refresh: '刷新',
    batchUpdate: '批量更新',
    export: '导出',
    selected: '已选择 {count} 项',
    total: '共 {total} 条反馈',
    pageInfo: '第 {page} / {totalPages} 页，共 {total} 条',
  },

  // 详情
  detail: {
    title: '反馈详情',
    backToList: '返回列表',
    submitter: '提交人',
    submitTime: '提交时间',
    updateTime: '更新时间',
    resolveTime: '解决时间',
    pageUrl: '页面 URL',
    browser: '浏览器信息',
    region: '所属区域',
    department: '部门',
    attachments: '附件',
    attachmentsWithCount: '附件（{count}）',
    attachmentItem: '附件 {index}',
    noAttachments: '无附件',
    timeInfo: '时间信息',
    techInfo: '技术信息',
  },

  // 管理操作
  admin: {
    updateStatus: '更新状态',
    updateStatusSuccess: '状态更新成功',
    changeStatus: '变更状态',
    priority: '优先级',
    setPriority: '设置优先级',
    prioritySuccess: '优先级设置成功',
    adminNote: '内部备注',
    adminNotePlaceholder: '添加内部备注（用户不可见）...',
    adminNoteSuccess: '备注保存成功',
    noteHint: '用户不可见',
    adminReply: '回复用户',
    adminReplyPlaceholder: '添加回复（用户可见）...',
    adminReplySuccess: '回复保存成功',
    replyHint: '用户可见',
    assignee: '处理人',
    assigneePlaceholder: '选择处理人',
    assigneeSuccess: '指派成功',
    delete: '删除反馈',
    deleteConfirm: '确定要删除这条反馈吗？删除后用户将无法看到。',
    deleteSuccess: '删除成功',
    batchUpdateTitle: '批量更新状态',
    batchUpdateStatus: '目标状态',
    batchUpdateConfirm: '确定要将 {count} 条反馈更新为 "{status}" 状态吗？',
    batchUpdateSuccess: '批量更新完成',
    batchUpdatePartialFail: '部分更新失败：{failed}/{total}',
  },

  // 统计
  stats: {
    title: '反馈统计',
    total: '总反馈数',
    pending: '待处理',
    inProgress: '处理中',
    resolved: '已解决',
    closed: '已关闭',
    todayNew: '今日新增',
    weekNew: '本周新增',
    monthNew: '本月新增',
    avgResolutionTime: '平均处理时长',
    hours: '小时',
    byType: '按类型分布',
    byStatus: '按状态分布',
    byPriority: '按优先级分布',
    byRegion: '按区域分布',
    showStats: '显示统计',
    hideStats: '隐藏统计',
  },

  // 表格列
  table: {
    content: '反馈内容',
  },

  // 悬浮按钮
  fab: {
    tooltip: '反馈与建议',
  },

  // 其他
  hasReply: '已回复',

  // 错误消息
  error: {
    loadFailed: '加载反馈失败',
    submitFailed: '提交反馈失败',
    updateFailed: '更新失败',
    deleteFailed: '删除失败',
    notFound: '反馈不存在',
    accessDenied: '无权访问此反馈',
    invalidStatusTransition: '无效的状态变更',
    titleRequired: '请输入标题',
    contentRequired: '请输入详细描述',
    typeRequired: '请选择反馈类型',
    titleTooLong: '标题不能超过 200 字符',
    contentTooLong: '内容不能超过 5000 字符',
    attachmentTooLarge: '单个附件不能超过 5MB',
    attachmentTypeInvalid: '仅支持图片格式（PNG/JPG/GIF/WebP）',
    attachmentUrlInvalid: '链接格式无效',
    attachmentsExceedLimit: '最多上传 5 张图片',
    batchLimitExceeded: '批量操作最多支持 100 条',
  },

  // 状态变更规则提示
  statusTransition: {
    hint: '状态变更规则：',
    pendingTo: '待处理 → 处理中 / 已关闭',
    inProgressTo: '处理中 → 已解决 / 已关闭 / 待处理',
    resolvedTo: '已解决 → 已关闭 / 处理中',
    closedTo: '已关闭 → 待处理',
  },
};
